import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styling/SandboxLogin.css";

const SandboxLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showToast, setShowToast] = useState(false);

  const HARDCODED_USERNAME = "DDW@Demo#X212";
  const HARDCODED_PASSWORD = "$LowDDW!Show@24&";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === HARDCODED_USERNAME && password === HARDCODED_PASSWORD) {
      setError("");
      setShowToast(true);

      // Toast duration before navigation
      setTimeout(() => {
        setShowToast(false);
        navigate("/Dashboard");
      }, 2000);
    } else {
      setError("Invalid credentials. Access denied.");
    }
  };

  return (
    <div className="sandbox-login-main-container">
      <div className="sandbox-login-card">
        <div className="sandbox-login-header">
          <h2>Digital Dreamworks</h2>
          <p>Sandbox Environment Access</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="sandbox-login-label">Username</label>
            <input
              type="text"
              className="form-control sandbox-login-input"
              placeholder="Enter sandbox username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="sandbox-login-label">Password</label>
            <input
              type="password"
              className="form-control sandbox-login-input"
              placeholder="Enter sandbox password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="sandbox-login-error">{error}</div>}

          <button type="submit" className="sandbox-login-btn">
            Enter Sandbox
          </button>
        </form>

        {showToast && (
          <div className="sandbox-toast">Access granted! Redirecting...</div>
        )}

        <div className="sandbox-login-footer">
          <small>Testing environment for Digital Dreamworks Agency</small>
        </div>
      </div>
    </div>
  );
};

export default SandboxLogin;
